import { useEffect } from "react";

type ActionToastProps = {
  message: string;
  onClose: () => void;
};

export default function ActionToast({ message, onClose }: ActionToastProps) {
  useEffect(() => {
    if (!message) {
      return;
    }
    const timer = window.setTimeout(onClose, 2600);
    return () => window.clearTimeout(timer);
  }, [message, onClose]);

  if (!message) {
    return null;
  }

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-6 z-50 flex justify-center px-4">
      <div className="animate-fade-up pointer-events-auto flex items-center gap-3 rounded-lg border border-background-200 bg-foreground-950 px-5 py-3 text-sm text-background-50">
        <span className="flex h-5 w-5 items-center justify-center">
          <i className="ri-checkbox-circle-fill text-base text-primary-400"></i>
        </span>
        {message}
      </div>
    </div>
  );
}